import { useDispatch } from "react-redux";
import { ChevronLeftIcon } from "components/lib/Shared/Icons/sflIcons";
import { useState, useContext } from "react";
import UpdateCompanyDetailsContext from "context/UpdateCompanyDetails";
import { useToast } from "hooks/useToast";

import CompanyOfficialsTab from "./CompanyOfficialsTab";

const StakeholderDetails = ({ handleGoBack, handleGoForward }) => {
  const dispatch = useDispatch();
  const { toast } = useToast(5000);
  const [addNewOfficialSelected, setAddNewOfficialSelected] = useState(false);
  const [canProceed, setCanProceed] = useState(true);
  const { transactions } = useContext(UpdateCompanyDetailsContext) || {};

  const handleValidationStatusChange = (isValid) => {
    setCanProceed(isValid);
  };

  const handleProceed = () => {
    if (!canProceed) {
      return;
    }

    // Check for undistributed shares (remainder > 0) in transactions
    let hasRemainder = false;
    if (transactions && Array.isArray(transactions)) {
      transactions.forEach((transaction) => {
        if (
          transaction.shareCapitalChanges &&
          Array.isArray(transaction.shareCapitalChanges)
        ) {
          transaction.shareCapitalChanges.forEach((change) => {
            const remainder = Number(change.remainder) || 0;
            if (remainder > 0) {
              hasRemainder = true;
            }
          });
        }
      });
    }

    if (hasRemainder) {
      toast(
        "error",
        "Please distribute the remaining shares to shareholders or adjust the shares on offer."
      );
      return;
    }

    handleGoForward();
  };

  return (
    <div>
      <CompanyOfficialsTab
        setAddNewOfficialSelected={setAddNewOfficialSelected}
        onValidationStatusChange={handleValidationStatusChange}
      />

      {!addNewOfficialSelected && (
        <div className="mt-4 px-4 py-3  sm:px-6">
          <div className="flex justify-between space-x-2">
            <div>
              {
                <button
                  type="button"
                  onClick={handleGoBack}
                  className="flex items-start float-right py-2 font-semibold rounded text-primary mt-7"
                >
                  <span className="flex items-center mr-4 h-7">
                    <ChevronLeftIcon
                      className="flex-shrink-0 w-5 h-5"
                      aria-hidden="true"
                    />
                  </span>
                  <p className="font-semibold">Go Back</p>
                </button>
              }
            </div>
            <button
              onClick={handleProceed}
              disabled={!canProceed}
              title={
                !canProceed
                  ? "Please resolve all beneficial ownership alerts before proceeding."
                  : ""
              }
              className={`${"flex items-center px-4 py-2 mb-2 font-semibold text-white rounded bg-sflPrimary mt-7 disabled:cursor-not-allowed disabled:opacity-50"}`}
            >
              Save and proceed
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StakeholderDetails;
